import type { FC, PropsWithChildren } from 'react'

import { unit } from '@hcr/ui'

import { Path } from '../../../../models/navigation'
import { DrawerNavigationBack } from '../../../common/drawer-navigation-back'

export const OwnerBenefitDetailsDrawer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <DrawerNavigationBack
      open={true}
      anchor='bottom'
      paddingBottom={unit(0)}
      paddingTop={unit(0)}
      paddingLeft={unit(0)}
      paddingRight={unit(0)}
      path={Path.Owner}
    >
      {children}
    </DrawerNavigationBack>
  )
}
